import React from 'react';
import { useTranslations } from 'next-intl';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useAppDispatch } from 'store';

import { useTopCourses } from 'modules/courses/hooks';
import { setCategoryIds, setSort, setType } from 'modules/courses/store';
import { globalConst, isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import CourseCard from '../course-card';
import CourseSkeleton from '../course-skeleton';
import SectionWrapper from '../section-wrapper';

const TopCourses = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { topCourses, isLoading } = useTopCourses();

  const onChangeType = () => {
    dispatch(setType('courses'));
    dispatch(setSort('popular'));
    dispatch(setCategoryIds(undefined));
  };

  return (
    <SectionWrapper onChange={onChangeType} title={t('mashxur_kurslar')} path={globalConst.pageNames.COURSES_FILTER}>
      <Visible
        if={isLoading}
        else={
          <Visible
            if={isEmptyArr(topCourses)}
            else={
              <>
                <Swiper slidesPerView="auto" modules={[FreeMode]} freeMode spaceBetween={9}>
                  {topCourses?.map(course => (
                    <SwiperSlide key={course?.id} className="min-w-63 max-w-63">
                      <CourseCard course={course} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </>
            }
          >
            <EmptyData title={t('malumot_topilmadi')} />
          </Visible>
        }
      >
        <div className="grid  grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <CourseSkeleton key={index} />
          ))}
        </div>
      </Visible>
    </SectionWrapper>
  );
};

export default TopCourses;
